import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/core/shared/shared.module';
import { ViewPdfComponent } from 'src/app/pages/master-data/program-config/components/view-pdf/view-pdf.component';

@Component({
  selector: 'vex-view-download-form-button',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './view-download-form-button.component.html',
  styleUrls: ['./view-download-form-button.component.scss']
})
export class ViewDownloadFormButtonComponent {
  @Input() viewLabel: string = 'View';
  @Input() downloadLabel: string = 'Download ';

  @Input() showViewFormBtn: boolean = true;
  @Input() showDownloadFormBtn: boolean = true;
  @Input() formUrl: string;
  @Input() formData: string;
  @Input() title: string = '';
  @Input() disableFiled: boolean = false;
  constructor(private dialog: MatDialog) {}
  onViewForm() {
    let dialogRef: MatDialogRef<ViewPdfComponent>;
    dialogRef = this.dialog.open(ViewPdfComponent, {
      width: '80%',
      data: {
        src: this.formUrl,
        title: this.title,
        disableFiled: this.disableFiled
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {});
  }

  onDownloadForm() {
    const fileUrl = this.formUrl;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'file'; // You can set the desired filename here
    document.body.appendChild(link);

    // Trigger a click on the link to start the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);
  }
}
